<!-- 通用公告组件 -->
<template>
  <div v-if="!$isEmpty(content)" class="announce">
    <p class="content"><span
      v-for="(item, index) in contentList"
      :key="index"
      :class="item.styleType"
      >{{item.content}}</span></p>
  </div>
</template>

<script>
export default {
  name: 'fund-announce',

  props: {
    content: {
      type: String,
      default: '',
    },
    hotKeys: {
      type: Array,
      default: () => ([]),
    },
    isShowClose: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    contentList() {
      let tmpContent = this.content;
      this.hotKeys.forEach((hotKey) => {
        tmpContent = tmpContent.replace(hotKey, `||${hotKey}||`);
      });
      const strArr = tmpContent.split('||');
      const finalArr = strArr.map((str) => ({
        content: str,
        styleType: this.hotKeys.includes(str) ? 'hotkey' : 'normal',
      }));
      console.log('===> common fund announce', finalArr);
      return finalArr || [];
    },
  },

};
</script>

<style lang="less" scoped>
.announce {
  padding: 24px;
  background-color: #FFFDEB;
  border: 1px solid #FFE780;
  border-radius: 12px;
  display: flex;
}
.content {
  display: inline;
  font-size: 28px;
  line-height: 0;
  margin: 0;
}
.normal {
  color: #333333;
  font-size: 28px;
  line-height: 42px;
  font-weight: 500;
}
.hotkey {
  color: #3A90FA;
  font-size: 28px;
  line-height: 42px;
  font-weight: 500;
}
</style>
